import ConfirmationModal from './ConfirmationModal'
import CreateModal from './CreateModal'
import SidePopUp from './Sidepopup'
import SearchTab from './SearchTab'
import CheckboxDropdown from './CheckboxDropdown'
import LightBox from './LightBox'
import CarouselComp from './Carousel'
import TopBar from './TopBar'
import PurchaseCard from './PurchaseCard'
import BillingSummary from './BillingSummary'
import ProductCard from './ProductCard'
import Filter from './Filter'
import PriceRange from './PriceRange'
import BulkSidePopUp from './BulkUpload/bulkUploadLightBox'
import CustomTable from './CustomTable'
import Barcode from './Barcode'
import ContactLensContainer from  "./ContactLensContainer"
import TableItemStatus from './TableStatus'
import LostBarcodeDetail from "./LostBarcodeDetail"
import CheckoutSummary from './CheckoutSummary'
import CheckoutCard from './Checkout'
import PermissionAccordion from "./PermissionAccordion"
import SelectionToggle from "./SelectionToggle"
import LensTable from "./LensTable"
import ToggleBarcodePrice from "./ToggleBarcodePrice"
import ProductFilter from "./ProductFilter"
import RoleLayout from './RoleLayout'
import CreateSideModal from "./CreateSideModal"


const molecules = {
    ConfirmationModal,
    CreateModal,
    SidePopUp,
    SearchTab,
    CheckboxDropdown,
    LightBox,
    CarouselComp,
    TopBar,
    PurchaseCard,
    BillingSummary,
    ProductCard,
    Filter,
    PriceRange,
    BulkSidePopUp,
    CustomTable,
    Barcode,
    ContactLensContainer,
    TableItemStatus,
    LostBarcodeDetail,
    CheckoutSummary,
    CheckoutCard,
    PermissionAccordion,
    SelectionToggle,
    LensTable,
    ToggleBarcodePrice,
    ProductFilter,
    RoleLayout,
    CreateSideModal
}
export default molecules